/**
 * Generic function-wrapping helpers to splice an extra callback before
 * (`preHook`) or after (`postHook`) an existing function without losing a
 * reference to the original (`unhook`) — used to attach a "run this too"
 * callback to a handler that's already wired elsewhere (e.g. an antd form's
 * `onFinish`) instead of replacing it outright.
 *
 * The default export is `postHook`, which about half of call sites import
 * (`import hook from "mibaby-common/util/hook"`) — the other half import `preHook`
 * directly, aliased to the same `hook` name.
 *
 * Part of the mibaby-common shared utilities & types component — see docs/wiki/System/shared/mibaby-common.md.
 */

/**
 * Unhook a hooked function.
 */
export function unhook(fn) {
  return fn.orig;
}

/**
 * Check if a function is hooked.
 */
export function isHooked(fn) {
  return "hooked" in fn && fn.hooked === true;
}

/**
 * Hook function by calling your custom callback and then the hooked function.
 */
export function preHook(orig, fn) {
  return createHook(orig, (...args) => (fn(...args), orig && orig(...args)));
}

/**
 * Hook function by calling it first and then your custom callback.
 */
export function postHook(orig, fn) {
  return createHook(orig, (...args) => (orig && orig(...args), fn(...args)));
}
function createHook(orig, fn) {
  const hooked = fn;
  hooked.hooked = true;
  hooked.orig = orig;
  return hooked;
}
export default postHook;
//# sourceMappingURL=hook.mjs.map